export const analyticsEventNames = [
  'onboarding_view',
  'auth_method_selected',
  'auth_verified',
  'permission_prompted',
  'permission_result',
  'recommendation_shown',
  'subscribe_clicked',
  'checkout_presented',
  'checkout_completed',
  'checkout_abandoned',
  'tutorial_completed',
  'free_drink_preview_view',
  'free_drink_assigned',
  'free_drink_granted',
  'free_drink_assignment_skipped',
  'free_drink_subscribe_prompt_shown',
  'free_drink_subscribe_start',
  'free_drink_subscribe_skipped',
  'merchant_signup_started',
  'merchant_signup_completed',
  'merchant_signup_failed',
  'user_signup_completed',
  'user_signup_failed',
  'subscription_purchase_started',
  'subscription_purchase_completed',
  'subscription_purchase_failed',
  'subscription_canceled',
  'page_view',
  'admin_action',
] as const;

export type AnalyticsEventName = (typeof analyticsEventNames)[number];

export type AnalyticsEventPayload = Record<string, unknown>;

export interface AnalyticsEventLog {
  id?: string;
  event: AnalyticsEventName;
  source: 'admin' | 'mobile';
  params?: AnalyticsEventPayload;
  createdAt: Date | string;
  userId?: string | null;
  sessionId?: string | null;
  platform?: 'web' | 'ios' | 'android';
  context?: Record<string, unknown>;
}
